/** @format */

import { create } from "zustand";

interface ApiLoadingState {
  /** Number of in-flight API requests. Loading overlay shows when > 0. */
  pendingCount: number;
  increment: () => void;
  decrement: () => void;
}

export const useApiLoadingStore = create<ApiLoadingState>((set) => ({
  pendingCount: 0,
  increment: () => set((s) => ({ pendingCount: s.pendingCount + 1 })),
  decrement: () => set((s) => ({ pendingCount: Math.max(0, s.pendingCount - 1) })),
}));
